module.exports = __webpack_public_path__ + "img/logo-minimum-sizes.fb917cb2.png";